import { ObterAnexos } from "./metodos/ObterAnexos";
import { ObterFormaDePagamentoDetalhada } from "./metodos/ObterFormaDePagamentoDetalhada";
import { ObterInformacoesPeloCodigo } from "./metodos/ObterInformacoesPeloCodigo";

export const PrevisaoDeComprasService = {
  ObterInformacoesPeloCodigo,
  ObterFormaDePagamentoDetalhada,
  ObterAnexos,
};